import { SettingOutlined } from "@ant-design/icons";
import { Button, Flex, Typography } from "antd";
import emptyStateClient from "../../assets/bg/no_client.svg";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import useSpecialityReference from "../../hooks/useSpecialityReference";
import { setShowSettingsModal } from "../../slices/appStateSlice";

interface EmptyStateClientProps {
  segment?: string;
}

const EmptyStateClient = ({ segment = "my" }: EmptyStateClientProps) => {
  const { referIndividualBy } = useSpecialityReference();
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);

  const getEmptyMessage = () => {
    if (segment === "shared") {
      return `No ${referIndividualBy.toLowerCase()}s have been shared.`;
    }
    return `Add ${referIndividualBy}s here.`;
  };

  const getSubMessage = () => {
    if (segment === "shared") {
      // Non-group users have no colleagues to receive shares from — say so
      // instead of promising shares that can never arrive.
      if (!userInfo.group_name) {
        return `Sharing ${referIndividualBy.toLowerCase()}s is only available for group accounts.`;
      }
      return `${referIndividualBy}s shared by colleagues will appear here.`;
    }
    return "Secure & HIPAA-Compliant.";
  };

  return (
    <Flex vertical align="center" justify="center">
      <img src={emptyStateClient} width={"50px"} alt="Empty State Client" />
      <Typography
        style={{
          color: "var(--secondary-text)",
          fontSize: "20px",
          marginTop: "10px",
        }}
      >
        {getEmptyMessage()}
      </Typography>
      <Typography
        style={{
          color: "var(--grey-text)",
        }}
      >
        {getSubMessage()}
      </Typography>
      {/* Sharing settings live in the Settings modal, but only group users have the section. */}
      {segment === "shared" && !!userInfo.group_name && (
        <Button
          type="primary"
          icon={<SettingOutlined />}
          style={{ marginTop: 16 }}
          onClick={() => dispatch(setShowSettingsModal(true))}
        >
          Sharing Settings
        </Button>
      )}
    </Flex>
  );
};

export default EmptyStateClient;
